export default __webpack_public_path__ + "static/media/home.2252a0b9.svg";